import React from "react";
import {Card} from 'react-bootstrap';

function STCCardSubtitle(props){
    return(
        <Card.Subtitle

            style={props.style}
            className={props.className}

            as={props.as}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Card.Subtitle>
    )
}
export default STCCardSubtitle;